import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { sileo } from "sileo";
import { useRegisterSW } from "virtual:pwa-register/react";

export function PWAUpdatePrompt() {
  if (window.electronAPI?.isElectron) return null;
  return <PWAUpdatePromptInner />;
}

function PWAUpdatePromptInner() {
  const { t } = useTranslation("common");
  const toastIdRef = useRef<string | null>(null);

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(err) {
      console.error("[pwa] sw register error", err);
    },
  });

  useEffect(() => {
    if (!needRefresh) return;

    toastIdRef.current = sileo.action({
      title: t("pwaUpdate.title"),
      description: t("pwaUpdate.description"),
      duration: null,
      button: {
        title: t("pwaUpdate.action"),
        onClick: () => {
          setNeedRefresh(false);
          updateServiceWorker(true);
        },
      },
    });

    return () => {
      if (toastIdRef.current) {
        sileo.dismiss(toastIdRef.current);
        toastIdRef.current = null;
      }
    };
  }, [needRefresh, setNeedRefresh, t, updateServiceWorker]);

  return null;
}
